import styled from 'styled-components/macro';
import { FlexCenterVertical } from 'styles/flexbox';
import { error, white } from 'variables/colors';
import { index10 } from 'variables/z-index';

export const StickyContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: ${index10};
  background-color: ${white};
`;

export const HeaderSection = styled.section`
  margin-bottom: 2em;
`;

export const OrganizationName = styled.h4`
  margin-bottom: 0.5em;
`;

export const Address = styled.p`
  font-size: 0.75em;
`;

export const SubRelationHeading = styled.h4`
  margin-bottom: 1em;
`;

export const SubRelationDetails = styled.p``;

export const BillTo = styled.div`
  display: grid;
  grid-column-gap: 1em;
  grid-template-columns: 1fr 1fr;
`;

export const LogoWarning = styled(FlexCenterVertical)`
  margin-top: 1em;
  color: ${error};
`;

export const LogoWarningText = styled.h6`
  margin-left: 0.5em;
`;
